import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const DEFAULT_MIME_TYPE = 'application/json';

const axiosGoogleInstance = axios.create({
  baseURL: process.env.GOOGLE_INTEGRATION_API_URL,
  timeout: 30000,
  headers: {
    Accept: DEFAULT_MIME_TYPE,
    'Content-Type': DEFAULT_MIME_TYPE
  }
});

// Add a request interceptor
axiosGoogleInstance.interceptors.request.use(requestInterceptor);

export default axiosGoogleInstance;



// WEBPACK FOOTER //
// ./src/common/api/googleIntegrationApi.js